import React, { useState, useImperativeHandle, useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import TContext from '../../context'
import PContext from '../context'
import Animate from '../../../animate'
import { Input, TextArea, Tabs, Range, Infiniteloading, Toast } from '@nutui/nutui-react';
import loadFont from '../../../../lib/font'
import http from '../../../../lib/http'
import * as apis from '../../../../lib/apis'
import { cloneDeep } from 'lodash';
var { AlphaPicker,SketchPicker  } = require('@hello-pangea/color-picker');

const textColor = ["#FFFFFF", "#000000", "#4D4D4D", "#808080", "#B3B3B3", "#E6E6E6", "#3b2722", "#5a3f34", "#9f877d", "#d4cbc4", "#556c78", "#90a0ad", "#ced6da", "#f7e6b0", "#f7f4c3", "#f1f5e6", "#e3f0fb", "#eae6f3", "#f4dae2", "#fad3cb", "#205d62", "#3a9284", "#8cba53", "#4d6d45", "#b7d332", "#a5cea3", "#84c4ba", "#a3bbe1", "#9ca1d0", "#4b9ed8", "#1d5192", "#1e296e", "#3f4fa0", "#432082", "#584096", "#853b92", "#831e4c", "#e60012", "#e24c3d", "#f188ac", "#f69796", "#f38435", "#e4ad35", "#edd481", "#f6f19d", "#f0cb59", "#be8a2f", "#2c2929"]


interface Props {
    action?: any
}

export interface Action {
    setShow?: (isShow: boolean) => void;
    editShow?: () => void; //编辑的显示
    confirm?: () => boolean;
    cancel?: () => void;
}

export const Height = 280

var previewTextObject: any = null
var tempJson: any = null

const Index = (props: Props) => {
    const [show, setInnerShow] = useState(false)
    const [currentColor, setCurrentColor] = useState<string>(textColor[1])
    const [fontWeight, setFontWeight] = useState<string>("normal")
    const [fontStyle, setFontStyle] = useState<string>("normal")
    const [fontFamily, setFontFamily] = useState<string>()
    const [fontOpacity, setFontOpacity] = useState<number>()
    const [inputText, setInputText] = useState<string>("")
    const [swiperClient, setSwiperClient] = useState<any>()
    const [paneKey, setPaneKey] = useState<number>()
    const [page, setPage] = useState<number>()
    const [fontList, setFontList] = useState<any>({ list: [], total: 0 })

    const tc = useContext(TContext)
    const pc = useContext(PContext)

    useImperativeHandle(props.action, (): Action => ({
        setShow,
        confirm,
        cancel,
        editShow
    }));

    //加载字体列表
    const loadList = async (page: number) => {
        try {
            const list: any = await http.get(apis.DESIGNER_FONT, {
                params: {
                    page: page,
                    limit: 10,
                }
            })
            if (page === 1) {
                setFontList(list)
                return list
            }
            let cpList: any = cloneDeep(fontList)
            cpList.total = list.total
            cpList.list = [...cpList.list, ...list.list]
            setFontList(cpList)
            return list
        } catch (error) {

        }
    }

    //加载更多
    const onLoadMore = async (done: () => void) => {
        let cpPage: any = cloneDeep(page)
        cpPage++
        setPage(cpPage)
        try {
            await loadList(cpPage)
        } catch (error) {
            let cpPage: any = cloneDeep(page)
            cpPage--
            setPage(cpPage)
        }
        done()
    }

    const editShow = () => {
        previewTextObject = tc.curActivityObject
        if (previewTextObject.type !== "text") {
            return
        }

        tempJson = tc?.fabricClient?.getJsonData()
        setPaneKey(0)
        setInnerShow(true)
        //初始字体
        setFontFamily(previewTextObject.fontFamily)
        //初始文字
        setInputText(previewTextObject.text)
        //设置颜色
        setCurrentColor(previewTextObject.fill)
        let colorIndex = textColor.findIndex(v => v === previewTextObject.fill)
        if (colorIndex === -1) {
            colorIndex = 0
        }
        swiperClient?.slideTo(colorIndex)
        //设置默认weight
        setFontWeight(previewTextObject.fontWeight || "normal")
        //设置默认斜体
        setFontStyle(previewTextObject.fontStyle || "normal")
        //设置默认字体透明度
        setFontOpacity(previewTextObject.opacity || 1)
    }

    const setShow = async (isShow: boolean) => {
        setInnerShow(isShow)
        if (isShow) {
            tempJson = tc?.fabricClient?.getJsonData()
            const defaultTxt = ""
            const defaultColor = textColor[1]
            setPaneKey(0)
            //初始空文字
            setInputText(defaultTxt)
            //显示之后就预先添加一个空文本对象
            previewTextObject = tc?.curCanvasClient?.addText(defaultTxt)
            //设置默认颜色
            setCurrentColor(defaultColor)
            swiperClient?.slideTo(textColor.findIndex(v => v === defaultColor))
            previewTextObject.set({ fill: defaultColor })
            //设置默认weight
            setFontWeight("normal")
            //设置默认斜体
            setFontStyle("normal")
            //设置默认字体透明度
            setFontOpacity(1)
            Toast.loading(t("加载字体"), {
                cover: true, // 是否展示透明遮罩层
                // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                closeOnClickOverlay: false, // 点击遮罩可关闭
                duration: 0
            })
            const list = await loadList(1)
            setPage(1)
            if (!list.list) {
                Toast.fail(t("缺少字体资源"))
                return
            }
            try {
                // await choiceFontFamily(list.list[0])
            } catch (error) {
                Toast.fail(t("字体加载失败"))
                return
            }
            Toast.hide()
        }
    }


    // //取消
    const cancel = () => {
        previewTextObject = null
        setInnerShow(false)
        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
    }
    //确认
    const confirm = () => {
        if (!previewTextObject) {
            return false
        }
        if (!previewTextObject.text.trim()) {
            return false
        }

        setInnerShow(false)
        tc.curCanvasClient.getFabricCanvas().setActiveObject(previewTextObject)
        tc.curCanvasClient.getFabricCanvas().renderAll()

        previewTextObject = null
        try {
            const ips: any = document.getElementsByClassName("nut-textarea__textarea")
            for (let i = 0; i < ips.length; i++) {
                ips[i].blur();
            }
        } catch (error) {

        }
        return true
    }


    //选择颜色
    const choiceColor = (color: string) => {
        setCurrentColor(color)
        previewTextObject.set({ fill: color })
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    //监听文字输入变化
    const inputOnchange = (val: any) => {

        setInputText(val)
        previewTextObject.text = val
        tc.curCanvasClient.getFabricCanvas().viewportCenterObject(previewTextObject)
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    const inputOnBlur = (e: any) => {
        let val = e.target.value
        setInputText(val)
        previewTextObject.text = val
        tc.curCanvasClient.getFabricCanvas().viewportCenterObject(previewTextObject)
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    //字体透明度变化
    const fontOpacityChange = (val: any) => {
		setFontOpacity(val?.hsv?.a)
		console.log(val)
		previewTextObject.set({ hsl: val?.hsl })
		previewTextObject.set({ rgb: val?.rgb })
		previewTextObject.set({ hex: val?.hex })
		previewTextObject.opacity = val?.hsv?.a
		tc.curCanvasClient.getFabricCanvas().renderAll()
		return
        setFontOpacity(val)
        previewTextObject.opacity = val
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    //tabs切换
    const tabOnChange = async ({ paneKey }: any) => {
        setPaneKey(paneKey)
    }

    //选择字体
    const choiceFontFamily = async (v: any) => {
        setFontFamily(`font${v.id}`)
        try {
            await loadFont(`font${v.id}`, v.path)
            Toast.hide()
        } catch (error) {
            Toast.fail(t("字体加载失败"))
        }
        previewTextObject.fontFamily = `font${v.id}`
        previewTextObject.set("font_family_url", v.path)
        tc.curCanvasClient.getFabricCanvas().renderAll()
    }

    return (
        <Animate show={show} style={{
            bottom: 0,
            position: "fixed",
            left: 0,
            zIndex: 11,
            width: "100%",
            background: "#FFFFFF",
            height: Height,
            paddingBottom: tc.safeHeigth
        }}>
            <div>
                <TextArea style={{ padding: 0, height: 30 }} defaultValue={inputText} onBlur={inputOnBlur} onChange={inputOnchange} placeholder={t('请输入文字')} />
            </div>
            <div>
                <Tabs background="#FFFFFF" value={paneKey} onChange={tabOnChange}>
                    <Tabs.TabPane title={t('样式')}>
                        <div style={{
                            height: 20,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-evenly"
                        }}>
                            <Swiper
                                onSwiper={s => setSwiperClient(s)}
                                slidesPerView={"auto"}
                                style={{
                                    width: "96%"
                                }}
                            >
                                {
                                    textColor?.map((v: any, k: number) => (
                                        <SwiperSlide onClick={(e) => {
                                            e.preventDefault()
                                            choiceColor(v)
                                        }} style={{
                                            width: 'auto'
                                        }} key={v}>
                                            <div style={{
                                                width: 20,
                                                height: 20,
                                                marginRight: k === textColor.length - 1 ? 0 : 12,
                                                borderRadius: "50%",
                                                background: v,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                border: `1px solid ${textColor[textColor.length - k - 1]}`
                                            }}>
                                                <div style={{
                                                    width: "60%",
                                                    height: "60%",
                                                    borderRadius: "50%",
                                                    border: currentColor === v ? `1px solid ${textColor[textColor.length - k - 1]}` : "none"
                                                }}></div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper>
                        </div>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: 24
                        }}>
                            <span style={{
                                fontSize: 12,
                                flexShrink: 0,
                                marginRight: 10
                            }}>{t('透明度')}</span>
                            
							<AlphaPicker color={ previewTextObject?.hex } rgb={ previewTextObject?.rgb } hsl={ previewTextObject?.hsl } width={"90%"} onChangeComplete={ fontOpacityChange }/>
                        </div>
                        {/* <div style={{
                            marginTop: 24
                        }}>
                            <div onClick={choiceFontWeight} style={{
                                width: 50,
                                height: 50,
                                border: fontWeight === "bold" ? "2px solid #000" : "2px solid #666",
                                color: fontWeight === "bold" ? "#000" : "#666",
                                borderRadius: 5,
                                fontSize: 14,
                                textAlign: "center",
                                verticalAlign: "middle",
                                display: "table-cell"
                            }}>
                                <div>B</div>
                                <div>粗体</div>
                            </div>
                            <div style={{
                                display: "table-cell",
                                width: 10
                            }}></div>
                            <div onClick={choiceFontStyle} style={{
                                width: 50,
                                height: 50,
                                border: fontStyle === "italic" ? "2px solid #000" : "2px solid #666",
                                color: fontStyle === "italic" ? "#000" : "#666",
                                borderRadius: 5,
                                fontSize: 14,
                                textAlign: "center",
                                verticalAlign: "middle",
                                display: "table-cell"
                            }}>
                                <div>I</div>
                                <div>斜体</div>
                            </div>
                        </div> */}
                    </Tabs.TabPane>
                    <Tabs.TabPane title={t('字体')}>
                        <div id="fontScroll" style={{
                            height: Height * 0.5,
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}>
                            <Infiniteloading
                                loadIcon=""
                                containerId="fontScroll"
                                useWindow={false}
                                hasMore={fontList?.total !== fontList?.list?.length}
                                onLoadMore={onLoadMore}
                            >
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3,auto)"
                                }}>
                                    {
                                        fontList?.list?.map((v: any) => (
                                            <div onClick={async () => {
                                                Toast.loading(t("加载字体"), {
                                                    cover: true, // 是否展示透明遮罩层
                                                    // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                                                    closeOnClickOverlay: false, // 点击遮罩可关闭
                                                    duration: 0
                                                })
                                                await choiceFontFamily(v)
                                                Toast.hide()
                                            }} style={{
                                                width: "28vw",
                                                marginBottom: "1vw",
                                                height: "15vw",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: 6,
                                                border: fontFamily === `font${v.id}` ? "1px solid #b0cd76" : "1px solid rgb(238, 238, 238)",
                                                background: v.cover ? `url("${v.cover + "?x-oss-process=image/resize,w_100"}")` : "#eee",
                                                backgroundSize: "100% 100%",
                                                backgroundPosition: "center center"
                                            }} key={v.id}>  {v.cover ? (
                                                <img
                                                    src={v.cover}
                                                    alt={t(v.name)}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover", // 保持图片的宽高比例，裁剪填满容器
                                                        borderRadius: 6
                                                    }}
                                                />
                                            ) : (
                                                t(v.name)
                                            )}</div>
                                        ))
                                    }
                                </div>
                            </Infiniteloading>
                        </div>

                    </Tabs.TabPane>
                </Tabs>
            </div>


        </Animate>

    )

}

export default Index
